import { render, staticRenderFns } from "./AssistantChatAgreement.vue?vue&type=template&id=3f560720&scoped=true"
import script from "./AssistantChatAgreement.vue?vue&type=script&lang=js"
export * from "./AssistantChatAgreement.vue?vue&type=script&lang=js"
import style0 from "./AssistantChatAgreement.vue?vue&type=style&index=0&id=3f560720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f560720",
  null
  
)

export default component.exports